import { fetchKnowledgePosts } from "@/api/apis";
import Header from "@/components/Header";
import { useEffect, useState } from "react";
import moment from "moment";
import { Calendar, ChevronRight, Volume2, VolumeX } from "lucide-react";
import { Link, useSearchParams } from "wouter";
import NewsletterSignup from "@/components/NewsletterSignup";
import Footer from "@/components/Footer";
import HTML_Renderer from "@/components/HTML_Renderer";

export default function KnowledgeHub({}) {
  const [posts, setPosts] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const postId = searchParams.get("post");
  const selectedPost = posts.find((p) => p.id == postId);
  useEffect(() => {
    fetchKnowledgePosts().then((res) => {
      setPosts(res.data.data);
    });
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
    });
  }, [postId]);

  return (
    <div className="min-h-screen bg-musicBlack">
      <Header />

      <section className=" relative overflow-hidden pt-24 pb-12">
        {/* Noise texture */}
        <div className="noise-overlay"></div>

        {/* Light blob effects */}
        <div className="light-blob light-blob--1"></div>
        <div className="light-blob light-blob--2"></div>

        <div className="editorial-container">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-white font-serif text-4xl md:text-6xl font-bold mb-6 animate-slide-in-top">
              Knowledge Hub
            </h1>
          </div>
        </div>
      </section>

      <main className="pt-12">
        <div className="editorial-container relative z-10">
          {!selectedPost && (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {posts
                .filter((p) => {
                  try {
                    return JSON.parse(p.title).en;
                  } catch (e) {
                    return false;
                  }
                })
                .map((p, i) => {
                  return (
                    <div className="col-md-4" key={i}>
                      <img
                        src={ p.image}
                        style={{
                          width: "100%",
                          borderRadius: "8px",
                          marginBottom: "15px",
                        }}
                      />
                      <div
                        style={{
                          display: "flex",
                          gap: "5px",
                          alignItems: "center",
                        }}
                        className="text-white"
                      >
                        <Calendar size={15} />
                        {moment(p.publish_date).format("DD MMM YYYY")}
                      </div>
                      <h4 className="text-white">
                        <Link href={"?post=" + p.id}>
                          {JSON.parse(p.title).en}
                        </Link>
                      </h4>
                    </div>
                  );
                })}
            </div>
          )}

          {selectedPost && (
            <div>
              <img src={selectedPost.image} style={{ width: "100%" }} />

              <h1
                style={{
                  fontSize: "45px",
                  marginTop: "20px",
                  marginBottom: "20px",
                }}
                className="text-white"
              >
                {JSON.parse(selectedPost.title).en}
              </h1>
              <div className="knowledge-hub-content">
                <HTML_Renderer
                  content={JSON.parse(selectedPost.content).en}
                  className={"mb-12"}
                />
              </div>
            </div>
          )}
        </div>
      </main>

      <div style={{ marginBottom: "70px" }}></div>

      <NewsletterSignup />
      <Footer />
    </div>
  );
}
